<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $t("cinemasettings") }}
      </div>
      <div>
        <router-link
          v-if="$can('update', 'Cinema Settings')"
          class="btn-blue"
          :to="
            '/cinema-manager/edit-cinema-settings?cinema_id=' +
            cinema_config.cine_id +
            '&cinema_setting_id=' +
            setting_id
          "
          >{{ $t("edit") }}</router-link
        >
        <router-link class="btn-blue" to="cinema-settings"
          >{{ $t("cinemasettings") }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div
      class="all-details-container"
      style="border: 2px solid rgb(56, 118, 210)"
    >
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b>{{ $tc("cinema", 2) }} {{ $t("name") }}</b>
                <div class="">
                  {{ selectedCinema }}
                </div>
              </div>
              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b>{{ $tc("language", 1) }}</b>
                <div
                  class=""
                  v-if="cinema_config.cine_application_language_id == 'Y'"
                >
                  {{ cinema_config.cine_application_language_id }}
                </div>
                <div v-else>-</div>
              </div>

              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b> {{ $t("Timezone") }} </b>
                <div class="">
                  {{ cinema_config.cine_time_zone }}
                </div>
              </div>

              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b>{{ $tc("status", 1) }}</b>
                <div
                  v-if="cinema_config.cine_setting_is_active == 'Y'"
                  class=""
                  style="color: green; font-weight: 600"
                >
                  {{ $t("active") }}
                </div>
                <div v-else class="" style="color: red; font-weight: 600">
                  {{ $t("inactive") }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 back new-border rounded-10 mb-2">
            <h6 class="font_20">Business</h6>
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-3">{{ $t('cinemaconessionlevel') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{cinema_config.cine_concession_level}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 back new-border rounded-10 mb-2">
            <h6 class="font_20">Business</h6>
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b style="white-space: nowrap">{{ $t("Start Time") }}</b>
                <div class="">
                  {{ cinema_config.cine_operation_start_time }}
                </div>
              </div>

              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b>{{ $t("End Time") }}</b>
                <div class="">
                  {{ cinema_config.cine_operation_end_time }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 back new-border rounded-10 mb-2">
            <h6 class="font_20">Entry</h6>
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b class="text-capitalize">{{ $t("after show start") }}</b>
                <div class="">
                  {{ cinema_config.entry_after_show_start }}{{ " min" }}
                </div>
              </div>

              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b class="text-capitalize">{{ $t("before show start") }}</b>
                <div class="">
                  {{ cinema_config.entry_before_show_start }}{{ " min" }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 back new-border rounded-10 mb-2">
            <h6 class="font_20">Discount On</h6>
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b>{{ $t("Net Amount") }}</b>
                <div class="">
                  {{ cinema_config.cine_offer_applicable_on_net | activeParse }}
                </div>
              </div>

              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b>{{ $t("Gross Amount") }}</b>
                <div class="">
                  {{
                    cinema_config.cine_offer_applicable_on_gross | activeParse
                  }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 back new-border rounded-10 mb-2">
            <h6 class="font_20">Time</h6>
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2 d-block">
                <b class="text-capitalize">{{ $t("advertisement") }}</b>
                <div class="">
                  {{ cinema_config.cine_setting_ads_time_in_mins }}{{ " min" }}
                </div>
              </div>

              <div class="col-md-3 col-lg-2 col-xl-2 d-block">
                <b class="text-capitalize">{{ $t("seat release") }}</b>
                <div class="">
                  {{ cinema_config.cine_seat_release_time_in_mins }}{{ " min" }}
                </div>
              </div>

              <div class="col-md-3 col-lg-2 col-xl-2 d-block">
                <b>Display:</b>

                <div
                  v-if="cinema_config.cine_display_24hr_time == 'Y'"
                  class=""
                >
                  24 Hour Display
                </div>
                <div v-else class="">12 Hour Display</div>
              </div>

              <div class="col-md-3 col-lg-2 col-xl-2 d-block">
                <b>{{ $t("Cleaning") }}</b>
                <div class="">
                  {{ cinema_config.cine_cleaning_time_in_mins }}{{ " min" }}
                </div>
              </div>

              <div class="col-md-3 col-lg-2 col-xl-2 d-block">
                <b>{{ $t("Interval") }}</b>
                <div class="">
                  {{ cinema_config.cine_interval_time_in_mins }}{{ " min" }}
                </div>
              </div>

              <div class="col-md-3 col-lg-2 col-xl-2 d-block">
                <b>Lead</b>
                <div class="">
                  {{ cinema_config.lead_time_in_hours }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 back new-border rounded-10 mb-2">
            <h6 class="font_20">Cutoff Time</h6>
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b> {{ $t("POS") }} </b>
                <div class="">
                  {{ cinema_config.cine_cutoff_time_in_mins }}{{ " min" }}
                </div>
              </div>

              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b>{{ $t("Kiosk") }}</b>
                <div class="">
                  {{ cinema_config.kiosk_cutoff_time_in_mins }}{{ " min" }}
                </div>
              </div>

              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b style="">{{ $t("Website") }}</b>
                <div class="">
                  {{ cinema_config.website_cutoff_time_in_mins }}{{ " min" }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 back new-border rounded-10 mb-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b>{{ $tc("onlinevisibility", 1) }}</b>
                <div
                  v-if="cinema_config.cine_online_visibility == 'Y'"
                  class=""
                  style="color: green; font-weight: 600"
                >
                  {{ $t("active") }}
                </div>
                <div v-else class="" style="color: red; font-weight: 600">
                  {{ $t("inactive") }}
                </div>
              </div>

              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b>{{ $t("include") }} {{ $t("floatAmount") }}</b>
                <div
                  v-if="cinema_config.cine_include_float_amount == 'Y'"
                  class=""
                  style="color: green; font-weight: 600"
                >
                  {{ $t("yes") }}
                </div>
                <div v-else class="" style="color: red; font-weight: 600">
                  {{ $t("no") }}
                </div>
              </div>

              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b>{{ $t("shiftclose") }}</b>
                <div
                  v-if="cinema_config.cine_include_shift_close == 'Y'"
                  class=""
                  style="color: green; font-weight: 600"
                >
                  {{ $t("yes") }}
                </div>
                <div v-else class="" style="color: red; font-weight: 600">
                  {{ $t("no") }}
                </div>
              </div>

              <div class="col-md-3 col-lg-2 col-xl-3 d-block">
                <b>{{ $t("ipaddressrange") }} :</b>
                <div class="">
                  {{ cinema_config.cine_ipaddress_range }}
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-3">{{ $t('registration') }} No.</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>-->

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-3">{{ $t('License') }} No.</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>-->

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-3">{{ $t('email') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>-->

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('contactno') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>-->

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('address') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>-->
          <!--
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('city', 2) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>-->

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('state', 2) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>-->

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('country', 2) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>-->

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('pincode') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>-->

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('latitude') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>-->

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('longitude') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>-->

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('noof') }} {{ $t('screens') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>-->

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{$t('english')}}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('spanish') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('arabic') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>-->

          <div class="col-md-12 py-2 back new-border rounded-10 mb-2">
            <div class="row">
              <div
                class="col-md-3 col-lg-2 col-xl-3 d-block"
                v-if="login_user_role_id === 1"
              >
                <b>{{ $t("createdby") }}</b>
                <div class="">
                  <span>{{ cinema_config.created_by }}</span>
                </div>
              </div>

              <div
                class="col-md-3 col-lg-2 col-xl-3 d-block"
                v-if="login_user_role_id === 1"
              >
                <b>{{ $t("createdat") }}</b>
                <div class="">
                  <span class="mr-3">{{
                    cinema_config.created_at | dateparse
                  }}</span>
                  <!-- <span>12:05 AM</span> -->
                </div>
              </div>

              <div
                class="col-md-3 col-lg-2 col-xl-3 d-block"
                v-if="login_user_role_id === 1"
              >
                <b>{{ $t("modifiedby") }}</b>
                <div class="">
                  <span>{{ cinema_config.updated_by }}</span>
                </div>
              </div>

              <div
                class="col-md-3 col-lg-2 col-xl-3 d-block"
                v-if="login_user_role_id === 1"
              >
                <b>{{ $t("modifiedat") }}</b>
                <div class="">
                  <span class="mr-3">{{
                    cinema_config.updated_at | dateparse
                  }}</span>
                  <!-- <span>12:05 AM</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import CinemasService from "@/services/CinemasService";
import scheduleService from "@/services/scheduleService";
import MasterService from "@/services/MasterService";
import moment from "moment";

export default {
  components: { Multiselect },
  data() {
    return {
      timeZones: [],
      login_user_role_id: null,
      selectedCinema: "",
      Cinemas: [],
      selected: null,
      setting_id: null,
      cinema_config: {
        cine_id: null,
        cine_offer_applicable_on_net: "",
        cine_offer_applicable_on_gross: "",
        cine_operation_start_time: "",
        cine_operation_end_time: "",
        cine_cleaning_time_in_mins: "",
        cine_setting_ads_time_in_mins: "",
        cine_interval_time_in_mins: "",
        cine_seat_release_time_in_mins: "",
        cine_cutoff_time_in_mins: "",
        kiosk_cutoff_time_in_mins: "",
        website_cutoff_time_in_mins: "",
        cine_ipaddress_range: "",
        cine_setting_is_active: true,
        cine_time_zone: "",
      },
      options: ["Kg", "Gms", "Lt", "Pks", "Ps"],
    };
  },
  beforeMount() {
    const { cinema_id } = this.$route.query;
    this.setting_id = this.$route.query.cinema_setting_id;
    this.cinema_config.cine_id = cinema_id;
    // console.log("query ", this.$route.query);
    // console.log(
    //   "setting cine id ",
    //   this.setting_id,
    //   this.cinema_config.cine_id
    // );
    if (cinema_id) {
      this.getCinemaList(cinema_id);
    } else {
      this.$router.go(-1);
    }
    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  methods: {
    getCinemaList: function (cinema_id) {
      CinemasService.GetActiveCinemas({ activekey: "cine_is_active" })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map((x) => {
              if (x.cine_id == cinema_id) {
                this.selectedCinema = x.cine_name;
                this.cinema_config.cine_id = x.cine_id;
              }
            });
            this.getCinemaSettings(cinema_id);
          } else {
            // Show Error Message:
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getTimeZones: function () {
      CinemasService.getTimeZoneList()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.timeZones = data.Records;
            for (let i in this.timeZones) {
              // console.log(
              //   "this.cinema_config.cine_time_zone :",
              //   this.cinema_config.cine_time_zone
              // );
              // console.log("this.timeZones[i].tz_id :", this.timeZones[i].tz_id);
              if (
                this.cinema_config.cine_time_zone === this.timeZones[i].tz_id
              ) {
                // console.log("heree");
                this.cinema_config.cine_time_zone = this.timeZones[i].tz_name;
              }
              // console.log("object :", this.cinema_config.cine_time_zone);
            }
            // this.timeZonesAll.map(x => {
            //   this.timeZones = x.tz_name;
            // });
            // console.log("time :", this.timeZones);
          } else {
            // Show Error Message:
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCinemaSettings: async function (cinema_id) {
      let payload = {
        cinema_id,
      };
      await scheduleService
        .GetCinemaSetting(payload)
        .then((response) => {
          const { data } = response;
          // console.log("Cine ID DATA : ", data);
          if (data && data.status && data.Records.length > 0) {
            this.cinema_config = {
              ...this.cinema_config,
              ...data.Records[0],
            };
            this.cinema_config.cine_operation_start_time = moment(
              moment().format("YYYY-MM-DD") +
                " " +
                this.cinema_config.cine_operation_start_time
            ).format("hh:mm A");

            this.cinema_config.cine_operation_end_time = moment(
              moment().format("YYYY-MM-DD") +
                " " +
                this.cinema_config.cine_operation_end_time
            ).format("hh:mm A");
            // console.log("cinema_config :", this.cinema_config);
            this.getViewUsersDetails(
              this.cinema_config.created_by,
              "created_by"
            );
            this.getViewUsersDetails(
              this.cinema_config.updated_by,
              "updated_by"
            );
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
      await this.getTimeZones();
    },
    getViewUsersDetails(user_id, key) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.cinema_config[key] = data.Records[0].user_name;
            } else {
              // Error Message
              // console.log("data.message :", data.message);
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      }
    },
  },
};
</script>

<style>
.back {
  background-color: #f5f5f5;
}
.font_20 {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemaSettingsComponents/viewCinemaSettings.vue